export default {
  page: {
    padding: "12px 24px",
  },
};
